import { isServiceableStatus } from './agreementStatus';
import type { RelationshipOption } from '../types/authorisedContacts.types';

export const RELATIONSHIP_LABEL: Record<RelationshipOption, string> = {
    spouse: 'Spouse',
    partner: 'Partner',
    parent: 'Parent',
    child: 'Child',
    sibling: 'Sibling',
    other: 'Other',
};

/** A stored relationship may be a chosen option or free text typed under 'Other'. */
export const relationshipLabel = (value: string): string =>
    Object.hasOwn(RELATIONSHIP_LABEL, value) ? RELATIONSHIP_LABEL[value as RelationshipOption] : value;

export const canManageAuthorisedContacts = (status: string): boolean => isServiceableStatus(status);
